export default __webpack_public_path__ + "static/media/splash-check.768b2dc9.svg";